export default __webpack_public_path__ + "static/media/image 120.ba2a524a.png";